import axios from '@axios'

export default {
  namespaced: true,
  state: { },
  getters: {},
  mutations: {},
  actions: {

    getDataFormulario(ctx, idFormulario) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/recursos/formulario/${idFormulario}/data`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getRespuestasPregunta(ctx, { idFormulario, idPregunta }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/recursos/formulario/${idFormulario}/respuesta?pregunta_id=${idPregunta}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
